import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/models/hockey-edition-overview",
  "description": "Любишь хоккей и автомобили? Встречай непревзойденную тройку игроков – особую серию ŠKODA Hockey Edition!",
  "huggerTemplate": "default",
  "keywords": "Hockey Edition karoq rapid octavia",
  "name": "hockey-edition-overview",
  "title": "Специальная серия Hockey Edition | ŠKODA"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const SimpleMainStageSubHeading = makeShortcode("SimpleMainStageSubHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionText = makeShortcode("DefaultSectionText");
const Heading = makeShortcode("Heading");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const AvnWidgetContainer = makeShortcode("AvnWidgetContainer");
const AvnWidgetTile = makeShortcode("AvnWidgetTile");
const VideoPlayer = makeShortcode("VideoPlayer");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="top" horizontalAlign="left" height={87} src="/m/heo-new-KV21-desk.jpg" mobileSrc="/m/heo-new-KV21-mobile.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading left mdxType="SimpleMainStageHeading">ŠKODA HOCKEY EDITION</SimpleMainStageHeading>
  <SimpleMainStageSubHeading fontSize={38} align="left" mdxType="SimpleMainStageSubHeading">
    ХОККЕЙ – НАША ИГРА
  </SimpleMainStageSubHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionText mdxType="DefaultSectionText">
    <Heading size="h3" center mdxType="Heading">
      <b>
        Когда команда ŠKODA HOCKEY EDITION «выходит на лед» - в победе можно не
        сомневаться!
      </b>
    </Heading>
  </DefaultSectionText>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading"> RAPID HOCKEY EDITION </DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      <Heading size="h5" center mdxType="Heading">
        Держит ситуацию под контролем!
      </Heading>
    </p>
  </DefaultSectionText>
  <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" height={88} src="/m/rapid-he-color2.jpg" mobileSrc="/m/rapid-he-color2-mobile.jpg" mdxType="SimpleMainStage" />
  <DefaultSectionText mdxType="DefaultSectionText">
    <p> </p>
    <p>
      Стремительный ŠKODA RAPID в новой экипировке и с кожаным мультирулем
      поможет вовремя перехватить инициативу и удерживать ее благодаря системе
      климат-контроля Climatronic.
    </p>
  </DefaultSectionText>
  <Heading size="h3" center mdxType="Heading">
    Особенности специальной серии
  </Heading>
  <FeaturesSliderQueried tags="rapid-hockey-edition overviewpage-new" mdxType="FeaturesSliderQueried" />
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/rapid-hockey-edition" type="secondary" mdxType="Button">
      Подробнее
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">OCTAVIA HOCKEY EDITION</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      <Heading size="h5" center mdxType="Heading">
        Видит всё, что происходит на льду!
      </Heading>
    </p>
  </DefaultSectionText>
  <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" height={88} src="/m/octavia-he-newimg4.jpg" mobileSrc="/m/octavia-he-newimg-mobile3.jpg" mdxType="SimpleMainStage" />
  <DefaultSectionText mdxType="DefaultSectionText">
    <p> </p>
    <p>
      ŠKODA OCTAVIA - надежный игрок команды HOCKEY EDITION имеет в основе
      комплектацию Ambition Plus, а также включает в себя передние и задние
      датчики парковки, камеру заднего вида с омывателем, тонировку задних
      стекол Sunset и многие другие полезные опции.
    </p>
  </DefaultSectionText>
  <Heading size="h3" center mdxType="Heading">
    Особенности специальной серии
  </Heading>
  <FeaturesSliderQueried tags="octavia-he-overviewpage" mdxType="FeaturesSliderQueried" />
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/octavia-hockey-edition" type="secondary" mdxType="Button">
      Подробнее
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">KAROQ HOCKEY EDITION</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    <p>
      <Heading size="h5" center mdxType="Heading">
        Уверенно движется к воротам соперника!
      </Heading>
    </p>
  </DefaultSectionText>
  <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" height={88} src="/m/karoq-he-color2.jpg" mobileSrc="/m/karoq-he-color2-mobile.jpg" mdxType="SimpleMainStage" />
  <DefaultSectionText mdxType="DefaultSectionText">
    <p> </p>
    <p>
      Маневренный ŠKODA KAROQ — это ещё одна модель, воплощающая философию
      марки. Как и в начале своего пути, ŠKODA стремится создавать автомобили,
      сочетающие великолепный дизайн и выдающийся уровень комфорта.
    </p>
  </DefaultSectionText>
  <Heading size="h3" center mdxType="Heading">
    Особенности специальной серии
  </Heading>
  <FeaturesSliderQueried tags="karoq-hockey-edition-spec" mdxType="FeaturesSliderQueried" />
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/models/karoq-hockey-edition" type="secondary" mdxType="Button">
      Подробнее
    </Button>
  </DefSectionBtnContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">Автомобили в наличии</DefaultSectionHeading>
  <DefaultSectionText mdxType="DefaultSectionText">
    Посмотрите какие автомобили ŠKODA есть в наличии у дилеров в Вашем городе
    прямо сейчас. Здесь вы найдете описание комплектаций и актуальные цены, а
    также сможете сравнить и забронировать понравившиеся автомобили одним
    кликом.
  </DefaultSectionText>
  <AvnWidgetContainer centered={true} mdxType="AvnWidgetContainer">
    <AvnWidgetTile imgSrc="/m/menu-new-rapid-he-1-3.png" title="RAPID" subTitle="Hockey Edition" align="center" verticalAlign="center" price="1 759 400 ₽" href="https://cars.skoda-avto.ru/rapid-hockey-edition" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/octavia-he-blue2.png" title="OCTAVIA" subTitle="Hockey Edition" align="center" verticalAlign="center" price="2 823 900 ₽" href="https://cars.skoda-avto.ru/octavia-hockey-edition" mdxType="AvnWidgetTile" />
    <AvnWidgetTile imgSrc="/m/karoq-he.png" title="KAROQ" subTitle="Hockey Edition" align="center" verticalAlign="center" price="2 966 900 ₽" href="https://cars.skoda-avto.ru/karoq-hockey-edition" mdxType="AvnWidgetTile" />
  </AvnWidgetContainer>
    </DefaultPaddedSection>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <VideoPlayer padding="16/9" previewSrc="/m/hockey-edition-2021-new-preview.jpg" videoSrc={{
        "video/mp4": "/m/hockey-edition-2021-new-video.mp4"
      }} mdxType="VideoPlayer" />
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      